<template>
  <layout-main-inner title="退货管理">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="title">
        <el-dropdown v-if="$route.path === '/goodsreturn-x'">
          <el-button type="primary">
            新建无码退货<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="addnotagreturn(1)">销售订单</el-dropdown-item>
            <el-dropdown-item @click.native="addnotagreturn(2)">调拨单</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <el-button
          v-if="$route.path === '/goodsreturn-x'"
          type="primary"
          icon="el-icon-plus"
          @click="addnotagreturn(1)">新建无码退货</el-button> -->
      </template>
      <template slot="form">
        <el-input
          v-model="config.dealOrderCode"
          clearable=""
          placeholder="请输入订单号"
          style="width: 200px;margin-right: 10px">
        </el-input>
        <el-input
          v-model="config.goodsReturnCode"
          clearable=""
          placeholder="请输入退货单号"
          style="width: 200px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="退货单号"
          :resizable="false"
          width="200">
          <template slot-scope="{row}">
            <link-route>
              <span @click="linkto(row)">{{ row.goodsReturnCode }}</span>
            </link-route>
            <el-tag v-if="row.hasTag === 0">无码</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="订单号"
          width="180"
          prop="dealOrderCode">
        </el-table-column>
        <el-table-column
          label="退货类型"
          width="90"
          :resizable="false"
          prop="billType">
          <template slot-scope="{row}">
            {{ row.billType === 2 ? '调拨退货' : '销售退货' }}
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="退货总数"
          width="100"
          prop="returnGoodsCount">
          <template slot-scope="{row}">
            <el-popover
              placement="right"
              trigger="hover">
              <el-table
                border=""
                :data="row.goodsReturnItems">
                <el-table-column
                  min-width="280"
                  property="productName"
                  label="商品名称"></el-table-column>
                <el-table-column
                  property="returnGoodsCount"
                  label="退货数量">
                  <template slot-scope="scope">{{ scope.row.returnGoodsCount }} {{ scope.row.measureUnit | measureUnitName() }}</template>
                </el-table-column>
              </el-table>
              <el-link
                slot="reference"
                style="font-size: 12px"
                type="primary">{{ row.returnGoodsCount }}</el-link>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="下单人信息"
          :resizable="false"
          prop="logisticsName">
          <template slot-scope="{row}">
            {{ row.deliveryName }}-{{ row.deliveryPhone }}-{{ row.detailedAddress }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="物流公司名称"
          :resizable="false"
          prop="logisticsName"></el-table-column>
        <el-table-column
          label="物流单号"
          :resizable="false"
          prop="logisticsNo"></el-table-column>
        <el-table-column
          :resizable="false"
          label="售后类型">
          <template slot-scope="{row}">
            {{ row.type | refundTypeName() }}
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="售后状态">
          <template slot-scope="{row}">
            {{ row.status | RefundStatusName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="退货原因"
          :resizable="false"
          width="100"
          prop="reason"></el-table-column> -->
        <el-table-column
          label="退单时间"
          :resizable="false"
          width="140">
          <template slot-scope="{row}">
            {{ row.goodsReturnTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="80"
          :resizable="false">
          <template slot-scope="{row}">
            {{ row.status === 0 ? '草稿': '已退货' }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="$route.path === '/goodsreturn-x'"
          label="操作"
          width="105">
          <template slot-scope="{row}">
            <el-button
              v-if="row.status === 0"
              type="warning"
              @click.native="agreereturn(row)">
              同意退货
            </el-button>
            <!-- <el-dropdown>
              <el-button type="warning">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="row.status === 0"
                  @click.native="agreereturn(row)">同意退货</el-dropdown-item>
                <el-dropdown-item @click.native="returndetail(row)">查看明细</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <!-- <el-button
              type="text"
              @click="viewDetail(row)">退货明细</el-button>
            <el-button
              v-if="row.hasTag === 1"
              type="text"
              @click="downloadreturntags(row)">下载</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <detail-modal ref="modal" />
    <order-select-modal
      ref="order"
      :options="{outType: 1, outStatusList: [1,2]}"
      :callback="getoutstockorder" />
    <transfer-select-modal
      ref="transfer"
      :callback="getoutstockorder1" />
    <notag-returen-modal
      ref="notag"
      :fetch="fetchList" />
    <agree-return-modal
      ref="agree"
      :fetch="fetchList" />
  </layout-main-inner>
</template>

<script>
import { mapState } from 'vuex'
import OrderSelectModal from './busi/order-select-modal.vue'
import NotagReturenModal from './busi/notag-returen-modal.vue'
import DetailModal from './detail-modal.vue'
import TransferSelectModal from './busi/transfer-select-modal.vue'
import AgreeReturnModal from './busi/agree-return-modal.vue'

// import ProductCountModal from '../outstock/busi/product-count-modal.vue'

export default {
  name: 'GoodsreturnList',
  components: { DetailModal, OrderSelectModal, TransferSelectModal, AgreeReturnModal, NotagReturenModal },
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        dealOrderCode: '',
        goodsReturnCode: ''
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      query: state => state.common.query,
      warehouse: state => state.account.warehouse
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    linkto(row) {
      if (row.billType === 1) {
        this.$store.dispatch('outstock/getsaleslist', {
          payload: {
            code: row.dealOrderCode
          },
          success: (res) => {
            const id = res.data.data.records[0].id
            this.$router.push(`/orders-detail?salesOrderId=${id}&code=${row.dealOrderCode}&activeName=3`)
          },
          fail: () => {}
        })
      }
      if (row.billType === 2) {
        this.$store.dispatch('outstock/allocatelist', {
          payload: {
            code: row.dealOrderCode
          },
          success: (res) => {
            const id = res.data.data.records[0].id
            this.$router.push(`/transfer-stock-detail?allocateOrderId=${id}&code=${row.dealOrderCode}&activeName=3`)
          },
          fail: () => {}
        })
      }
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('goodsreturn/getgoodsreturns', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    addnotagreturn(type) {
      if (type === 1) {
        this.$refs.order.fetch()
      } else {
        this.$refs.transfer.fetch()
      }
    },
    getoutstockorder(id) {
      this.$store.dispatch('outstock/salesdetail', {
        payload: {
          salesOrderId: id
        },
        success: res => {
          // this.toggleModal(false)
          // this.callback && this.callback(res.data.data)
          this.$refs.notag.init({
            ...res.data.data,
            type: 1,
            warehouseName: (this.warehouse.find(i => i.warehouseNo === res.data.data.warehouseNo) || {}).warehouseName
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getoutstockorder1(row) {
      this.$refs.notag.init({
        type: 2,
        vendorId: row.vendorId,
        code: row.dealOrderCode,
        warehouseNo: row.warehouseNo,
        postSaleOrderNumber: row.postSaleOrderNumber,
        warehouseName: (this.warehouse.find(i => i.warehouseNo === row.warehouseNo) || {}).warehouseName,
        detailList: row.details.map(i => {
          return {
            ...i,
            returnGoodsCount: i.goodsCount
          }
        })
      })
      // this.$store.dispatch('outstock/allocatedetail', {
      //   payload: {
      //     allocateOrderId: id
      //   },
      //   success: res => {
      //     // this.toggleModal(false)
      //     // this.callback && this.callback(res.data.data)
      //     this.$refs.notag.init({
      //       ...res.data.data,
      //       warehouseNo: res.data.data.sourceWarehouseNo,
      //       warehouseName: (this.warehouse.find(i => i.warehouseNo === res.data.data.sourceWarehouseNo) || {}).warehouseName
      //     })
      //   },
      //   fail: () => {
      //     this.loading = false
      //   }
      // })
    },
    // downloadreturntags(row) {
    //   this.loading = true
    //   this.$store.dispatch('goodsreturn/downloadreturntags', {
    //     payload: {
    //       goodsReturnId: row.goodsReturnId,
    //       vendorId: row.vendorId
    //     },
    //     success: () => {
    //       this.loading = false
    //     },
    //     fail: () => {
    //       this.loading = false
    //     }
    //   })
    // },
    agreereturn(row) {
      this.$refs.agree.init(row)
      // this.$confirm('是否同意退货?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     this.loading = true
      //     this.$store.dispatch('goodsreturn/submitgoodsreturn', {
      //       payload: {
      //         draftGoodsReturnId: row.goodsReturnId
      //       },
      //       success: () => {
      //         this.loading = false
      //         this.fetchList()
      //       },
      //       fail: () => {
      //         this.loading = false
      //       }
      //     })
      //   })
    },
    returndetail(row) {
      console.log(row)
      this.$refs.modal.fetch(row)
    }
  }
}
</script>
<style lang="stylus"></style>
